module.exports = __webpack_public_path__ + "media/images/category/rank1-5e8a285b1a4051c21ea713403253f1ab.gif";